import { Controller } from 'react-hook-form';
import { Form, Input, Button, Row, Col, theme as themeAntd } from 'antd';

// // @ts-ignore
import ImagemLogo from './../../assets/images/logo.png';

import './style.css';

import Loading from '../../components/Loading';
import useRecoveryPassword from './useRecoveryPassword';

const RecoveryPassword = () => {
    const {
        user,
        handleSubmit,
        onSubmit,
        isSubmiting,
        isLoadingUser,
        formRef,
        errors,
        control,
        pathBackgroundImage,
    } = useRecoveryPassword();

    const { token: {
        colorBgContainer
    } } = themeAntd.useToken();


    if (isLoadingUser) {
        return <Loading loading={isLoadingUser} />
    }

    return (
        !user ?
            <Row
                gutter={24}
                style={{
                    maxHeight: "100vh",
                    margin: 0,
                    backgroundColor: colorBgContainer,
                }}
                align="middle"
            >
                <Col
                    className='fotoFundoLogin'
                    style={{
                        backgroundImage: `url(${pathBackgroundImage})`,
                        backgroundSize: 'cover',
                        width: '20%',
                        height: '100vh',
                    }}
                    flex={3}
                />
                <Col
                    flex={1}
                    style={{
                        height: '100vh',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        maxWidth: '563px'
                    }}
                >
                    <Loading loading={isSubmiting} >
                        <Form
                            name="formRecoveryPassword"
                            ref={formRef}
                            initialValues={{
                                remember: true,
                            }}
                            onFinish={handleSubmit(onSubmit)}
                        >
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <img
                                    src={ImagemLogo}
                                    alt="Logo Nota Município"
                                    style={{
                                        width: '290px',
                                        // margin: '20px'
                                    }}
                                />
                            </div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                margin: 30
                            }}>

                                <Form.Item
                                    style={{
                                        marginBottom: 15,
                                        maxWidth: '100%',
                                    }}
                                    label="Nova senha"
                                    required
                                    validateStatus={errors.password ? 'error' : 'success'}
                                    help={errors.password?.message}
                                >
                                    <Controller
                                        name="password"
                                        control={control}
                                        rules={{
                                            required: {
                                                value: true,
                                                message: 'Por favor, digite sua nova senha!'
                                            },
                                            minLength: {
                                                value: 8,
                                                message: 'A senha precisa ter no mínimo 8 caracteres!'
                                            }
                                        }}
                                        render={({ field }) => <Input.Password {...field} autoComplete="off" placeholder="Nova senha" />}
                                    />
                                </Form.Item>
                                <Form.Item
                                    style={{
                                        marginBottom: 15
                                    }}
                                    label="Confirme a nova senha"
                                    required
                                    validateStatus={errors.confirmPassword ? 'error' : 'success'}
                                    help={errors.confirmPassword?.message}
                                >
                                    <Controller
                                        name="confirmPassword"
                                        control={control}
                                        rules={{
                                            required: {
                                                value: true,
                                                message: 'Por favor, confirme sua nova senha!'
                                            }
                                        }}
                                        render={({ field }) => <Input.Password {...field} autoComplete="off" placeholder="Confirme a nova senha" />}
                                    />
                                </Form.Item>

                                <Button
                                    type="primary"
                                    style={{ width: "100%" }}
                                    htmlType='submit'
                                    disabled={isSubmiting}
                                >
                                    Entrar
                                </Button>
                            </div>
                        </Form>
                    </Loading>
                </Col>
            </Row>
            : null
    );
};

export default RecoveryPassword;
